import React from 'react';
import { useSelector } from 'react-redux';
import { Breadcrumbs } from 'src/components/breadcrumbs';
import { AppContext } from 'src/components/app-context';
import type {
  BreadcrumbsSlice,
  Breadcrumb as BreadcrumbSliceType,
} from '../../../../types';
import type { AppState } from 'src/reducers';
import * as S from './styles';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

type BreadcrumbType = BreadcrumbSliceType & {
  id: string;
  pathName: string;
};

type BreadcrumbSliceProps = {
  categoryIds?: string[];
} & BreadcrumbsSlice;

const BreadcrumbSlice = ({ items, categoryIds }: BreadcrumbSliceProps) => {
  const { t } = React.useContext(AppContext);

  const activeCampaigns = useSelector((state: AppState) =>
    state.globals.campaignBanners.active.filter(
      (campaign?: { type: string }) => campaign?.type === 'DURING_PROMO_BANNER'
    )
  );

  return (
    <>
      {!!activeCampaigns?.length && (
        <S.StyledPromoBanner
          className="product-collection-promo-banner"
          banners={activeCampaigns}
          linkParams={{ category: categoryIds?.join('|') }}
        />
      )}
      <Breadcrumbs
        homeText={t('common', 'breadcrumb.home')}
        path={
          items
            .map(item =>
              item?.pathName
                ? {
                    ...item,
                    id: item.pathName,
                  }
                : undefined
            )
            .filter(x => x) as BreadcrumbType[]
        }
        onClick={(nextPage: string) =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.BREADCRUMB,
            nextPage,
          })
        }
      />
    </>
  );
};

export default BreadcrumbSlice;
